let selectedPlanId = localStorage.getItem('selectedPlanId');
let selectedOptionId = localStorage.getItem('selectedOptionId');

if (selectedPlanId !== null && selectedPlanId !== 'undefined' && selectedOptionId !== null) {
    // Both exist
    window.location.href = '/cart/clear?return_to=/cart/add?items[][id]='+selectedOptionId+'%26items[][quantity]=1%26items[][selling_plan]='+selectedPlanId+'%26return_to=/checkout';
} else if (selectedPlanId !== null) {
    // Only selectedPlanId exists
    window.location.href = '/cart/'+selectedOptionId+':1?checkout';
} else {
    // Neither exists
    window.location.href = '/404';
}